<template>
  <div class="search-wrap" @click="handleClickTarget($event)">
    <div style="background-color: #fff;">
      <div class="search">
        <img class="search-icon" src="../assets/common/search.png" />
        <input
          v-model="searchKey"
          type="text"
          class="search-input"
          placeholder="请输入搜索内容"
          @keyup.13="handleKeyBoardEnter"
        />
        <span class="ver-line"></span><span class="cancle-btn" @click="handleCancel">取消</span>
      </div>
      <transition :css="false">
        <div ref="searchRes" class="search-result-warp">
          <div v-show="showSlide" class="search-result">
            <div v-show="searchResStatus === 0">
              <div v-show="searchHistory && searchHistory.length" class="searchHistory">
                <!-- 搜索历史 -->
                <p class="type-tit">搜索记录</p>
                <p v-for="(item, index) in searchHistory" :key="index" @click="enterSearchDetail(item)">{{ item }}</p>
              </div>
              <div v-show="topQuestion && topQuestion.length" class="topQuestion">
                <!-- 热门问题 -->
                <p class="type-tit">热门问题</p>
                <p v-for="(item, index) in topQuestion" :key="index" @click="enterSearchDetail(item.content)">
                  <span :id="item.qesId" class="item-content" type="topQuestion">{{ item.content }}</span>
                </p>
              </div>
            </div>
            <div v-show="searchResStatus === 1">
              <div v-show="usingInfo && usingInfo.length" class="usingInfo">
                <!--使用手册 -->
                <p class="type-tit">使用手册</p>
                <p
                  v-for="(item, index) in usingInfo"
                  :key="index"
                  @click="
                    enterSearchDetail(
                      searchKey,
                      'usingInfo',
                      item.id,
                      (item.version ? item.version : 'ColorOS 7').split(' ')[1]
                    )
                  "
                  v-html="splitContent(item, searchKey, 'usingInfo')"
                ></p>
              </div>
              <div v-show="news && news.length" class="news">
                <p class="type-tit">新闻资讯</p>
                <p
                  v-for="(item, index) in news"
                  :key="index"
                  @click="enterSearchDetail(searchKey, 'news', item.id)"
                  v-html="splitContent(item, searchKey, 'news')"
                ></p>
              </div>
            </div>
            <div v-show="searchResStatus === 2" class="search_loading">
              <img :src="search_loading" />
              <span class="content">加载中...</span>
            </div>
            <div v-show="searchResStatus === 3" class="noSearchRes">
              很抱歉，暂未找到匹配结果
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { getTopQuestion, getSearchFetch } from '@/api/index.js';
export default {
  components: {},
  props: {
    visible: {
      type: Boolean, // true 移动端 false pc <- from app.vue
      default: true
    },
    searchVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      search_loading: require('@/assets/common/search_loading.png'),
      searchKey: '',
      searchHistory: [], // 搜索记录
      topQuestion: [], // 热门问题
      usingInfo: [], // 使用手册
      news: [], // 新闻资讯
      searchResStatus: 0, // 0待搜索 1 搜索完成 2 搜索中 3 无数据
      timer: null,
      showSlide: true
    };
  },
  watch: {
    searchKey: function() {
      this.denounce(1000);
    },
    searchVisible(val) {
      if (val) {
        this.searchKey = '';
        this.slideEnter();
      }
    }
  },
  created() {
    this.getSearchHistory();
    this.getTopQuestion();
  },
  methods: {
    getSearchHistory() {
      this.visible
        ? (this.searchHistory = JSON.parse(localStorage.getItem('mobile_searchHistory')))
        : (this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')));
    },
    setSearchHistory(key) {
      if (!key) return;
      let searchList = this.visible
        ? JSON.parse(localStorage.getItem('mobile_searchHistory')) || []
        : JSON.parse(localStorage.getItem('searchHistory')) || [];
      //搜索去重，限制数量，本地保存
      if (!searchList.includes(key)) {
        searchList.length >= 3 ? searchList.shift() : '';
        searchList.push(key);
        this.visible
          ? localStorage.setItem('mobile_searchHistory', JSON.stringify(searchList))
          : localStorage.setItem('searchHistory', JSON.stringify(searchList));
        this.searchHistory = searchList;
      }
    },
    getTopQuestion() {
      getTopQuestion().then(res => {
        if (res.code !== 200) {
          return new Error(res);
        }
        this.topQuestion = res.data;
      });
    },
    getRenderAjax(type, searchKey) {
      let params = {
        version: 0,
        type: type, // 0 使用手册， 1 新闻， 2 全部
        question: searchKey,
        page: 1,
        pageSize: 3,
        distinct: 1
      };
      return new Promise((reslove, reject) => {
        getSearchFetch(params).then(res => {
          if (res.code !== 200) {
            reject(res.msg);
          }
          reslove(res.data);
        });
      });
    },
    // 内容分割
    splitContent(data, key) {
      let html = '';
      let headerText, footerText;
      let keyContent = '';
      let keyCase = key.toUpperCase();
      let dataTitleCase = data.title.toUpperCase();
      if (dataTitleCase.search(keyCase) === -1) {
        html = '<span class="item-content">' + data.title + '</span>';
        return html;
      }
      if (keyCase.length > 1) {
        // 关键词长度>=2
        if (dataTitleCase.search(keyCase) == 0) {
          headerText = '';
          footerText = dataTitleCase.slice(keyCase.length);
        } else {
          headerText = dataTitleCase.slice(0, dataTitleCase.search(keyCase));
          footerText = dataTitleCase.slice(dataTitleCase.search(keyCase) + keyCase.length);
        }
      } else {
        if (dataTitleCase.search(keyCase) !== -1 || dataTitleCase.search(keyCase) == 0) {
          headerText = dataTitleCase.slice(0, data.title.indexOf(keyCase));
        } else {
          headerText = '';
        }
        footerText = dataTitleCase.slice(dataTitleCase.search(keyCase) + 1);
      }

      if (headerText) {
        keyContent = '&nbsp' + '<span class="keyWord">' + key + '</span>' + '&nbsp';
      } else {
        keyContent = '<span class="keyWord">' + key + '</span>' + '&nbsp';
      }
      html +=
        '<span class="item-content">' +
        '<span>' +
        headerText +
        '</span>' +
        keyContent +
        '<span>' +
        footerText +
        '</span>' +
        '</span>';

      return html;
    },
    // 防抖、节流 delay: 时长 ms
    denounce(delay) {
      if (this.timer) {
        this.searchKey.length >= 30 ? (this.searchKey = this.searchKey.slice(0, 30)) : '';
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.writing();
      }, delay);
    },
    writing() {
      // searchResStatus 0待搜索 1 搜索完成 2 搜索中 3 无数据

      this.searchResStatus = 0;
      this.usingInfo = this.new = [];
      this.slideLeave();
      if (this.searchKey) {
        this.searchResStatus = 2;
        setTimeout(() => {
          let promises = [this.getRenderAjax(1, this.searchKey), this.getRenderAjax(0, this.searchKey)];
          Promise.all(promises).then(res => {
            // res -> defalult [] array

            this.usingInfo = res[0];
            this.news = res[1];
            (this.usingInfo && this.usingInfo.length) || (this.news && this.news.length)
              ? (this.searchResStatus = 1)
              : (this.searchResStatus = 3);
            // $('.search-result-warp').hide().slideDown();
            setTimeout(() => {
              this.slideEnter();
            });
          });
        }, 20);
      } else {
        this.searchResStatus = 0;
        // this.slideLeave();
        setTimeout(() => {
          this.slideEnter();
        }, 20);
      }
    },
    // searchKey回车
    handleKeyBoardEnter() {
      if (this.searchKey && (this.usingInfo.length || this.news.length)) {
        this.enterSearchDetail(this.searchKey);
      }
    },
    enterSearchDetail(searchKey, type, id, version) {
      // let baseOrigin = location.origin.search("localhost") ? "http://www.colorostest.wanyol.com/" : location.origin;
      let baseOrigin = location.origin.search('localhost') ? 'http://www.coloros.com' : location.origin;
      this.setSearchHistory(searchKey); // 保存搜索记录
      // 服务端保存搜索记录
      sessionStorage.setItem('keyWord', JSON.stringify(searchKey));
      // 搜索记录、热门问题 -> 搜索结果，使用手册、新闻资讯 -> 详情；
      if (type) {
        if (type === 'usingInfo') {
          window.open(`${baseOrigin}/instruction?id=${id}&version=ColorOS ${version}`);
        } else {
          window.open(`${baseOrigin}/index/newsDetail?id=${id}`);
        }
      } else {
        window.open(`${baseOrigin}/index/searchResults`);
      }
    },
    // click取消
    handleCancel() {
      this.searchKey = '';
      this.is_slided = true;
      this.$parent.searchVisible = false;
    },
    handleClickTarget($event) {
      let status = $event.target.className.search('search-wrap');
      console.log($event.target.className);
      status !== -1 ? (this.$parent.searchVisible = false) : '';
    },
    slideEnter() {
      let el = this.$refs.searchRes;
      el.style.height = 'auto';
      let height = window.getComputedStyle(el, null)['height'];
      el.style.height = '0';
      //不设定延迟height不会有动画
      setTimeout(function() {
        el.style.height = height;
        el.style.opacity = 1;
      }, 20);
    },
    slideReset() {
      let el = this.$refs.searchRes;
      el.style.height = '0';
    },
    slideLeave() {
      let el = this.$refs.searchRes;
      el.style.height = '50px';
    }
  }
};
</script>

<style lang="scss" scoped>
.search-wrap {
  user-select: none;
  opacity: 0;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.search-wrap .search {
  width: 100%;
  height: 55px;
  line-height: 55px;
  background: #fff;
  padding: 0 20px;
  font-size: 0;
  box-sizing: border-box;
}

.search-wrap .search-icon {
  width: 18px;
  vertical-align: middle;
  margin-top: 2.5px;
  margin-right: 10px;
}

.search-wrap .search-input {
  width: calc(100% - 100px);
  height: 20px;
  padding-top: 4px;
  font-size: 16px;
  color: #000;
  vertical-align: middle;
  outline: none;
  border: none;
}

.search-wrap .search-input::-webkit-input-placeholder {
  font-size: 16px;
  color: #999;
}

.search-wrap .search-input::-moz-placeholder {
  font-size: 16px;
  color: #999;
}

.search-wrap .search-input:-ms-input-placeholder {
  font-size: 16px;
  color: #999;
}

.search-wrap .search-input::-ms-input-placeholder {
  font-size: 16px;
  color: #999;
}

.search-wrap .search-input::placeholder {
  font-size: 16px;
  color: #999;
}

.search-wrap .ver-line {
  display: inline-block;
  height: 16px;
  width: 1px;
  border-right: 1px solid #e5e5e5;
  vertical-align: middle;
  margin-right: 20px;
}

.search-wrap .cancle-btn {
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
}

.search-result-warp {
  background: #fff;
  overflow: hidden;
  text-align: left;
  transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
}
.search-result-warp.slideClose {
  height: 0;
}
.search-result-warp.show {
  padding: 0 20px 30px 20px;
}

.search-wrap .search-result {
  padding-left: 27px;
  border-top: 1px solid #e5e5e5;
  transition: all 0.5s ease-in-out;
  p {
    margin: 0.6rem;
  }
  margin: 20px;
  margin-top: 0;
}
.search-result > div {
  margin-top: 30px;
}
.search-result .type-tit {
  opacity: 0.5;
  font-size: 16px;
  line-height: 30px;
  color: #000;
  letter-spacing: 1px;
  mix-blend-mode: normal;
}

.search-result .type-item {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.search-result .type-item a {
  color: #000;
}
.search-result div .type-item:last-child {
  margin-bottom: 0;
}

/* .mobile-search-result > div:first-child .type-tit {
    margin-top: 0; } */
.search-result .keyWord {
  font-variation-settings: 'wght' 750;
}

.search-wrap-show {
  z-index: 1001;
  opacity: 1;
  -webkit-transition: all 1s ease-in-out;
  transition: all 1s ease-in-out;
}

.search-result .noSearchRes {
  margin-bottom: 30px;
  text-align: left;
  font-size: 16px;
  line-height: 30px;
  color: #999;
  font-family: PingFangSC;
}
.search-result .search_loading {
  margin: 16px 0;
  width: 100%;
  display: flex;
  align-items: center;
}

.search-result .search_loading .content {
  margin-left: 10px;
  font-size: 16px;
  color: #000;
  opacity: 0.5;
}
.search-result .search_loading img {
  width: 15px;
  height: 15px;
  animation-duration: 1s;
  animation: rotate 1s linear infinite;
}
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
@-webkit-keyframes opacityShow {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes opacityShow {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes indexNavLeftLineTop {
  0% {
    top: 0;
    -webkit-transform: none;
    transform: none;
  }

  to {
    top: 7px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}

@keyframes indexNavLeftLineTop {
  0% {
    top: 0;
    -webkit-transform: none;
    transform: none;
  }

  to {
    top: 7px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}

@-webkit-keyframes indexNavLeftLineBottom {
  0% {
    top: 13px;
    -webkit-transform: none;
    transform: none;
  }

  to {
    top: 7px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
}

@keyframes indexNavLeftLineBottom {
  0% {
    top: 13px;
    -webkit-transform: none;
    transform: none;
  }

  to {
    top: 7px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
}
@keyframes slideDown {
  0% {
    height: 0;
  }
  100% {
    height: 100%;
  }
}

.search-pc {
  margin-top: 104px;
  .search {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 140px;
    height: auto;
    text-align: left;
    .search-icon {
      margin-right: 0;
    }
    .search-input {
      margin-left: 20px;
      height: 34px;
      border: none;
      color: #000;
      outline: none;
      background-color: transparent !important;
      font-size: 24px;
    }
    .search-input::-webkit-input-placeholder {
      font-size: 24px;
    }

    .search-input::-moz-placeholder {
      font-size: 24px;
    }

    .search-input:-ms-input-placeholder {
      font-size: 24px;
    }

    .search-input::-ms-input-placeholder {
      font-size: 24px;
    }

    .search-input::placeholder {
      font-size: 24px;
    }
  }
  .search-result-warp {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 140px;
    box-sizing: border-box;
    .search-result {
      padding-left: 10px;
    }
    p {
      line-height: 30px;
    }
  }
}

@media screen and (max-width: 734px) {
  .search-wrap .ver-line,
  .search-wrap .cancle-btn {
    display: none;
  }
}
</style>
